import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "@react/shared/ui/Button"

// Page title + the single "Nouveau modèle" action (no export on this page).
const Header = ({ onNewClick }) => (
  <div className="flex items-start justify-between gap-6 mb-6">
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">
        {I18n.t("quotes.project_quote_templates.index.title")}
        <span className="text-slate-400 font-normal ml-2">
          {I18n.t("quotes.project_quote_templates.index.subtitle")}
        </span>
      </h1>
      <p className="text-sm text-slate-500 mt-1">
        {I18n.t("quotes.project_quote_templates.index.description")}
      </p>
    </div>

    <div className="flex items-center gap-2">
      <Button variant="primary" onClick={onNewClick}>
        <FontAwesomeIcon icon="plus" />
        {I18n.t("quotes.project_quote_templates.index.new")}
      </Button>
    </div>
  </div>
)

export default Header
